import { General } from "../../../siteManagement/general";
import { Grid } from "../../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { SkillChangeLog } from "./skillsInterfaces";
import React from "react";

export interface SkillChangeLogProps {
    RefNr: string;
    RefPos: number;
}

export class SkillChangeLogGrid extends React.Component<SkillChangeLogProps, {
    GridData: SkillChangeLog[];
}>{
    private _gridOptions = {
        dataSource: {
            schema: {
                model: {
                    fields: {
                        Wann: { type: "date" }
                    }
                }
            },
        },
        sortable: true,
        pageable: true,
        groupable: true,
        filterable: true,
        selectable: true,
        resizable: true,
        columns: [
            {
                field: "ChangeDateUtc",
                title: Helper.getTranslation("WebSMS.Log.Wann"),
                template: "#= kendo.toString(kendo.parseDate(ChangeDateUtc), 'G') #",
                width: 80
            },
            {
                field: "FieldTypeDescription",
                title: Helper.getTranslation("WebSMS.Log.Spaltenname"),
                width: 80
            },
            {
                field: "CategoryDescription",
                title: Helper.getTranslation("WebCRM.EditIndividualCategories.Category"),
                width: 120
            },
            {
                field: "SkillDescription",
                title: Helper.getTranslation("WebSMS.Skills.Skill"),
                width: 120
            },
            {
                field: "OldValue",
                title: Helper.getTranslation("WebSMS.Log.Altwert"),
                width: 120
            },
            {
                field: "NewValue",
                title: Helper.getTranslation("WebSMS.Log.Neuwert"),
                width: 120
            },
            {
                field: "ChangeUser",
                title: Helper.getTranslation("WebSMS.Log.Wer"),
                width: 80
            }
        ]
    };

    constructor(props) {
        super(props);
        this.state = {
            GridData: null
        };
    }

    componentDidMount() {
        this.loadData();
    }

    private loadData = async () => {
        let result = await HTTPService.get<JsonResultClass<SkillChangeLog[]>>("SkillChangeLog/GetChangeLog", { refNr: encodeURIComponent(this.props.RefNr), refPos: this.props.RefPos });
        if (result.Code == 0) {
            this.setState({ GridData: result.Data });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.RELOAD) {
            this.loadData();
        }
    }

    onSelectionChanged = (dataItem: SkillChangeLog) => {
        if (Helper.hasValue(dataItem)) {
            let item = dataItem;
            let baseText = difflib.stringAsLines(item.OldValue.toString());
            let newText = difflib.stringAsLines(item.NewValue.toString());

            let sm = new difflib.SequenceMatcher(baseText, newText);
            let opcodes = sm.get_opcodes();

            const sheet = General.Sheet.Manager.createSheet();
            sheet.setTitle(Helper.getTranslation("WebSMS.Log.Differenz"));
            sheet.show(() => {
                sheet.appendStringContent(diffview.buildView({
                    baseTextLines: baseText,
                    newTextLines: newText,
                    opcodes: opcodes,
                    baseTextName: Helper.getTranslation("WebSMS.Log.Altwert"),
                    newTextName: Helper.getTranslation("WebSMS.Log.Neuwert"),
                    contextSize: null,
                    viewType: 0
                }));
            });
        }
    }

    private createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.RELOAD, caption: Helper.getTranslation("MonitorBaum.NeuLaden"), enabled: true });
        return <Grid data={this.state.GridData} options={this._gridOptions} id="skillChangeLog"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} onSelectionChanged={this.onSelectionChanged} />;
    }

    render() {
        let grid = Helper.hasValue(this.state.GridData) ? this.createGrid() : null;
        return (<>
            {grid}
        </>);
    }
}